import api from './apiHelper';

export const uploadImage = (formData, folderName) => {
  let url = '/upload';
  if (folderName) {
    url = `/upload/${folderName}`;
  }
  return api.post(url, formData);
};
